export default "/_next/static/chunks/fonts/Calibri-BoldItalic-005ff6d588cfb1c15de1dce828bba3e6.ttf";